export default {"src":"/_next/static/media/entrp.0a9efa54.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};